import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with auth interceptor
const authApi = axios.create({ baseURL: API });

// Add token to requests
authApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============== AUTH API ==============
export const authService = {
  login: (email, password) =>
    axios.post(`${API}/auth/login`, { email, password }),
  register: (email, password, name) =>
    axios.post(`${API}/auth/register`, { email, password, name }),
  getMe: () => authApi.get(`${API}/auth/me`),
  logout: () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
  },
  setToken: (token) => localStorage.setItem("auth_token", token),
  setUser: (user) => localStorage.setItem("auth_user", JSON.stringify(user)),
  getToken: () => localStorage.getItem("auth_token"),
  getUser: () => {
    const user = localStorage.getItem("auth_user");
    return user ? JSON.parse(user) : null;
  },
  isAuthenticated: () => !!localStorage.getItem("auth_token"),
};

// ============== ADMIN API ==============
export const adminApi = {
  // Niches
  getNiches: () => axios.get(`${API}/admin/niches`),
  createNiche: (data) => axios.post(`${API}/admin/niches`, data),
  getNiche: (id) => axios.get(`${API}/admin/niches/${id}`),
  deleteNiche: (id) => axios.delete(`${API}/admin/niches/${id}`),

  // Products
  getProducts: (nicheId = null) => {
    const params = nicheId ? { niche_id: nicheId } : {};
    return axios.get(`${API}/admin/products`, { params });
  },
  createProduct: (data) => axios.post(`${API}/admin/products`, data),
  getProduct: (id) => axios.get(`${API}/admin/products/${id}`),
  updateProduct: (id, data) => axios.put(`${API}/admin/products/${id}`, data),
  deleteProduct: (id) => axios.delete(`${API}/admin/products/${id}`),

  // Content Generation
  generateContent: (data) => axios.post(`${API}/admin/content/generate`, data),

  // Scraper
  getScraperConfigs: () => axios.get(`${API}/admin/scraper/configs`),
  createScraperConfig: (data) => axios.post(`${API}/admin/scraper/configs`, data),
  runScraper: (productId) => axios.post(`${API}/admin/scraper/run/${productId}`),

  // Analytics
  getAnalytics: (nicheId = null) => {
    const params = nicheId ? { niche_id: nicheId } : {};
    return axios.get(`${API}/admin/analytics/summary`, { params });
  },
};

// ============== PUBLIC API ==============
export const publicApi = {
  getNiches: () => axios.get(`${API}/public/niches`),
  getNicheBySlug: (slug) => axios.get(`${API}/public/niches/${slug}`),
  getProductsByNiche: (slug, featuredOnly = false) =>
    axios.get(`${API}/public/niches/${slug}/products`, {
      params: { featured_only: featuredOnly },
    }),
  getProductBySlug: (slug) => axios.get(`${API}/public/products/${slug}`),
  trackClick: (data) => axios.post(`${API}/public/track-click`, data),
};

// ============== HEALTH CHECK ==============
export const healthCheck = () => axios.get(`${API}/health`);
